import React, {useState} from "react";
import QrCodeContext from "./qrCodeContext";

export interface QrCodeProviderProps {
    children: React.ReactNode
}

const QrCodeContextProvider: React.FC<QrCodeProviderProps> = ({children}) => {
    const [open, setOpen] = useState(false)
    const [title, setTitle] = useState('')
    const [image, setImage] = useState('')

    const updateValues = (newOpen: boolean, newTitle: string, newImage: string) => {
        setOpen(newOpen)
        setTitle(newTitle)
        setImage(newImage)
    }

    const contextValues = {
        open,
        title,
        image,
        updateValues
    }

    return <QrCodeContext.Provider value={contextValues}>{children}</QrCodeContext.Provider>

}

export default QrCodeContextProvider